export enum MetaTable {
  PRODUCT = 'product',
  BLOG = 'blog',
  CATEGORY = 'category',
  BRAND = 'brand',
}
